import { Slot } from 'radix-ui';
import type * as React from 'react';

import { cn } from '@/lib/utils';

/* `asChild` 를 달았다. 이 앱은 판을 `<section>`·`<article>` 로 쓰던 자리가
   많은데, 받아온 판은 `<div>` 로 못박혀 있어 **옮길 때마다 구획 요소가
   조용히 사라졌다.** `<Card asChild><section>…</section></Card>` 로 되살린다. */
function Card({
  className,
  asChild = false,
  ...props
}: React.ComponentProps<"div"> & { asChild?: boolean }) {
  const Comp = asChild ? Slot.Root : 'div';
  return (
    <Comp
      data-slot="card"
      className={cn(
        // 테두리 색을 못박는다 — preflight 를 안 들이므로 `border` 만으로는
        // `currentColor`(잉크색)가 돼 판마다 새까만 선이 그어진다.
        'flex flex-col gap-s4 rounded-lg border border-line bg-panel py-s4 text-ink shadow-panel',
        className
      )}
      {...props}
    />
  )
}

/* `[.border-b]:pb-*` 를 걷었다. 그 변형은 명시도가 (0,2,0) 이라 저자가 준
   `py-s4`(0,1,0)를 이겨 **밑줄을 그으면 아래 여백이 제멋대로 벌어진다.**
   실제로 걸렸다(2026-08-25). 밑줄이 필요하면 `border-b` 를 그냥 달아라. */
function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn(
        '@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-s2 px-s5 has-data-[slot=card-action]:grid-cols-[1fr_auto]',
        className
      )}
      {...props}
    />
  )
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-content"
      className={cn('px-s5', className)}
      {...props}
    />
  )
}

export {
  Card,
  CardHeader,
  CardContent,
}
